export const lastGDMUpdate = (state) => state.lastGDMUpdate;
export const publishStatus = (state) => state.publishStatus;
export const exportFinished = (state) => state.exportFinished;
export const getImportInProgress = (state) => state.isImportInProgress;
export const getEntitySelected = (state) => state.entitySelected;
